import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, NavigationExtras } from '@angular/router';
import { Observable } from 'rxjs';
import { SecurityService } from '../services/security.service';

@Injectable({
    providedIn: 'root'
})
export class CanActivateGuard implements CanActivate, CanActivateChild, CanLoad {

    constructor(private _securityService: SecurityService,
        private _router: Router) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        const currentUser = this._securityService.currentUserValue;
        const reportProblemNavigationExtras: NavigationExtras = { state: { message: 'morate_se_prijaviti_prijava_problema' } };
        const loginNavigationExtras: NavigationExtras = { state: { message: 'Nemate pravo pristupa!' } };

        if (currentUser) {
            if (next.data.roles && next.data.roles.indexOf(currentUser.roleName) === -1) {
                this.redirectToLoginAndShowMessage(state);
                return false;
            }
            return true;
        }
        this.redirectToLoginAndShowMessage(state)
        return false;
    }    

    canActivateChild(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return true;
    }
    canLoad(
        route: Route,
        segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
        return true;
    }

    redirectToLoginAndShowMessage(state: RouterStateSnapshot) {
        const reportProblemNavigationExtras: NavigationExtras = { state: { message: 'morate_se_prijaviti_prijava_problema' } };
        const loginNavigationExtras: NavigationExtras = { state: { message: 'nemate pravo pristupa!' } };

        if (state.url.indexOf('report-problem') === -1) {
            this._router.navigate(['/login'], loginNavigationExtras);
        }
        else {
            this._router.navigate(['/login'], reportProblemNavigationExtras);
        }
    }
}
